import { IconButton, Theme, lighten, useTheme } from "@mui/material";

interface Props {
  size?: "small" | "medium" | "large";
  children: React.ReactNode;
  onClick?: (ev: any) => void;
  isDisabled?: boolean;
}

export function OutlinedIconButton({
  size = "medium",
  children,
  onClick,
  isDisabled,
}: Props) {
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <IconButton
      disabled={isDisabled}
      size={size}
      sx={styles.root}
      onClick={onClick}
    >
      {children}
    </IconButton>
  );
}

function useStyles(theme: Theme) {
  return {
    root: {
      border: `1px solid ${theme.palette.divider}`,
    },
  };
}
